import { useTranslation } from 'react-i18next'
import { VscBracketError  } from "react-icons/vsc";

import './error.scss'

function Me() {
  const { t } = useTranslation()
  
  return (
    <div className='page-error'>
      <div className='error-container'>
        <div className='container-title'>4<VscBracketError  />4</div>
        <div className='container-subTitle'>{t('error.title')}</div>
      </div>
    </div>
  )
}

export default Me
